const setUser = payload => ({
  type: "SET_USER",
  payload
});

const setAlertMessage = payload => ({
  type: "SET_ALERT_MESSAGE",
  payload
});

const removeAlertMessage = payload => ({
  type: "REMOVE_ALERT_MESSAGE",
  payload
});

const removeUser = payload => ({
  type: "REMOVE_USER",
  payload
});

const openSidebar = () => ({
  type: "OPEN_SIDEBAR",
  payload: null
});

const closeSidebar = () => ({
  type: "CLOSE_SIDEBAR",
  payload: null
});

const showLoader = () => ({
  type: "SHOW_LOADER",
  payload: null
});

const hideLoader = () => ({
  type: "HIDE_LOADER",
  payload: null
});

const setAllEmployers = payload => ({
  type: "SET_ALL_EMPLOYERS",
  payload
});

const setRelationShips = payload => ({
  type: "SET_RELATIONSHIPS",
  payload
});

const setAccountOfficerInfo = payload => ({
  type: "SET_ACCOUNT_OFFICER_INFO",
  payload
});

export default {
  setUser,
  setAlertMessage,
  removeAlertMessage,
  removeUser,
  openSidebar,
  closeSidebar,
  showLoader,
  hideLoader,
  setAllEmployers,
  setRelationShips,
  setAccountOfficerInfo
};
